export const TOP_PADDING = 16
export const BOTTOM_PADDING = 24

// Minimum scroll distance to consider a programmatic scroll
// This is used to detect scrolling down programmatically (e.g. via a deep link)
// to set the sidebar to the top of the viewport
export const PROGRAMMATIC_SCROLL_DELTA_THRESHOLD = 600

// Additional height below the sidebar to ensure scrolling down fast dosen't cause issues
export const BOTTOM_SENTINEL_HEIGHT = 300
